export const ALBUM_FOLDER_MEMBERS_IMPORT_MODE = {
  GENERAL: 'GENERAL',
  UNIFORM: 'UNIFORM',
};
